export default __webpack_public_path__ + "static/media/Seven.be88b68e.png";